<template>
    <div class="saved-orders">
        <div v-if="ordersData" class="page">
            <div class="cover"></div>
            <div class="container">
                <div class="content">
                    <h1>Comenzi salvate</h1>
                    <p v-if="ordersData.total > 0">Se afișează rezultatele {{ ordersData.from }}-{{ ordersData.to }} din {{ ordersData.total }}.</p>
                    <p v-else>Se afișează 0 rezultate.</p>

                    <div class="white-page" v-if="ordersData.total === 0">
                        <h1>Nicio comandă</h1>
                        <p>
                            Nicio comandă nu a fost salvată până acum.
                        </p>
                    </div>

                    <div v-else>
                        <div class="white-page">
                            <table class="table table-sm table-borderless table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">ID</th>
                                        <th scope="col">Furnizor</th>
                                        <th scope="col">Dată comandă</th>
                                        <th scope="col">Număr produse</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="order in ordersData.data" :key="order.id">
                                        <td>{{order.id}}</td>
                                        <template>
                                            <td v-if="order.supplier_names">{{order.supplier_names}}</td>
                                            <td v-else><i>Necunoscut</i></td>
                                        </template>
                                        <td>{{formatDate(order.created_at)}}</td>
                                        <td>{{order.product_count}}</td>
                                        <td class="nowrap">
                                            <router-link :to="`/order/${order.id}/view`" v-slot="{ href, navigate }">
                                                <a :href="href" @click="navigate">
                                                    <b-button variant="primary" size="sm">
                                                        <b-icon icon="eye" />
                                                        Vezi comanda
                                                    </b-button>
                                                </a>
                                            </router-link>
                                            <router-link :to="`/order/${order.id}/edit`" v-slot="{ href, navigate }">
                                                <a :href="href" @click="navigate">
                                                    <b-button variant="secondary" size="sm" class="ml-2">
                                                        <b-icon icon="pencil-square" />
                                                        Editează
                                                    </b-button>
                                                </a>
                                            </router-link>
                                            <b-button variant="danger" size="sm" class="ml-2" @click="() => deleteOrder(order.id)">
                                                <b-icon icon="trash" />
                                                Șterge
                                            </b-button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                            <b-pagination
                                v-model="page"
                                :total-rows="ordersData.total"
                                :per-page="ordersData.per_page"
                                @change="changePage"
                                align="right"
                                first-number
                                last-number
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "@/utils/axios-instance";
    import moment from "moment";

    export default {
        name: 'SavedOrders',
        components: {},
        data() {
            return {
                errorMessage: null,
                page: 1,

                ordersData: null,
            }
        },
        computed: {
            groupID() {
                return this.$route.params.id
            }
        },
        created: async function () {
            let loader = this.$loading.show();
            await this.loadOrders();
            loader.hide();
        },
        watch: {
            // call again the method if the route changes
            '$route': 'fetchData'
        },
        methods: {
            async loadOrders() {
                let {data} = await axios.get(`order/get-all?page=${this.page}`);

                if(this.page > data.last_page) {
                    this.page = data.last_page;
                    await this.loadOrders();

                    return;
                }

                this.ordersData = data;
            },
            async changePage(page) {
                let loader = this.$loading.show();

                this.page = page;
                await this.loadOrders();

                loader.hide();
            },
            async deleteOrder(orderId) {
                let loader = this.$loading.show();

                try {
                    await axios.delete(`order/${orderId}`);
                    await this.loadOrders();
                } catch (e) {
                    console.log(e);
                }

                loader.hide();
            },
            formatDate(date) {
                return moment(date).format('DD.MM.YYYY')
            }
        }
    }
</script>

<style scoped>
    .saved-orders {
        flex-grow: 1;
        display: flex;
    }

    .page {
        flex-grow: 1;
        position: relative;
    }

    .cover {
        width: 100%;
        height: 264px;
        position: relative;
        background: #024A8C;
    }

    .container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .content {
        margin-top: 60px;
        color: white;
        width: 100%;
    }

    .white-page {
        background: white;
        border-radius: 5px;
        color: black;
        padding: 25px 20px;

        margin-top: 50px;
        margin-bottom: 20px;

        -webkit-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        -moz-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
    }

    .white-page h1 {
        color: #024A8C;
        font-weight: 600;
    }

    .white-page h2, h3, h4, h5, h6 {
        color: #6F6F6F;
        margin-top: 10px;
    }

    h1 {
        font-size: 2rem;
    }

    h2 {
        font-size: 1.1rem;
    }

    h3 {
        font-size: 1rem;
    }

    th {
        color: #024A8C;
        font-weight: 600;
    }

    table td {
        white-space: normal;
        vertical-align: middle;
    }

    table td.nowrap {
        width: 1%;
        white-space: nowrap;
    }

    .product-codes {
        color: #6F6F6F;
        font-size: 0.7rem;
        word-wrap: break-word;
    }
    .product-codes span::after {
        content: '; ';
    }

    .total-profit {
        color: #024A8C;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .total-profit .profit {
        font-weight: 800;
        font-size: 1.3rem;
    }

    .currencies div {
        margin-bottom: 5px;
    }
</style>
